<script>
import MainMessage from '@/components/MainMessage/index.vue'

export default {
    components:{
        MainMessage,
    }
}
</script>

<template src="./template.html"></template>
<style src="./style.css"></style>